package devxertech.com.component

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Style

@Composable
fun CustomStyles() {
    Style {

        "*" {

            property("scrollbar-width", "thin")
            property("scrollbar-color", "#0ABAB1 #f1f1f1")
        }

        "::-webkit-scrollbar" {
            property("width", "10px")
        }

        "::-webkit-scrollbar-track" {
            property("background", "#f1f1f1")
        }

        "::-webkit-scrollbar-thumb" {
            property("background", "#0ABAB1")
            property("border-radius", "5px")
        }

        "::-webkit-scrollbar-thumb:hover" {
            property("background", "#555")
        }
        "ul.custom-ul-clean" {
            property("list-style", "none")
            property("padding-left", "0")
            property("margin", "0")
        }
    }
}
